module.exports = __webpack_public_path__ + "img/icon_zhichiduozhongduan.71f446e6.png";